import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin, from } from 'rxjs';
import { UserService } from './core/user/user.service';

/**
 * Blocks every dashboard navigation until these resolve, so it must only contain what the shell
 * genuinely needs to render.
 *
 * It used to also fetch messages, notifications, quick-chat and shortcuts - four Fuse demo
 * endpoints whose components this app's layout never renders. Each navigation paid for data
 * nobody displayed.
 */
export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const userService = inject(UserService);

    return forkJoin([
        // Drives the side menu, and is filtered by the user's roles.
        navigationService.get(),
        // Identity shown in the toolbar.
        from(userService.get()),
    ]);
};
